// Trace ID with hover-labelled buttons for copying the log-inspector link and
// the ID itself.

import React from 'react';
import PropTypes from 'prop-types';
import { t } from '@lingui/macro';
import { Button, Flex, Popover } from '@decisiv/ui-components';
import Copy from '@decisiv/iconix/lib/components/Copy';
import Link from '@decisiv/iconix/lib/components/Link';

import { CopyButtonWrap, FullWidthRow } from './style';

const CopyAction = ({ icon, label, onCopy }) => (
  <Popover
    placement="bottom-start"
    manageEvents="hover"
    target={({ ref }) => (
      <CopyButtonWrap>
        <Button
          ref={ref}
          icon={icon}
          aria-label={label}
          variant="ghost"
          size="small"
          onClick={onCopy}
        />
      </CopyButtonWrap>
    )}
  >
    <Flex padding={1}>
      <span>{label}</span>
    </Flex>
  </Popover>
);

CopyAction.propTypes = {
  icon: PropTypes.elementType.isRequired,
  label: PropTypes.string.isRequired,
  onCopy: PropTypes.func.isRequired,
};

export default function TraceIdCell({ traceId = '' }) {
  return (
    <FullWidthRow alignItems="center" justifyContent="space-between">
      <span>{traceId}</span>
      <span>
        <Flex alignItems="center">
          <CopyAction
            icon={Link}
            label={t`Copy Link to Log Inspector`}
            onCopy={() =>
              navigator.clipboard.writeText(
                `${window.location.origin}/toolkit/log_inspector/${traceId}`,
              )
            }
          />
          <CopyAction
            icon={Copy}
            label={t`Copy ID`}
            onCopy={() => navigator.clipboard.writeText(traceId)}
          />
        </Flex>
      </span>
    </FullWidthRow>
  );
}

TraceIdCell.propTypes = { traceId: PropTypes.string };
